export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  image: string;
  excerpt: string;
  date: string;
  views: string;
  hot: boolean;
  tags: string[];
  author: string;
  content: string;
}

export const allArticles: Article[] = [
  {
    id: 'article-1',
    title: '顶流男星深夜私会女粉丝？录音曝光后全网哗然',
    slug: 'dingliu-nanxing-si-hui',
    category: '明星私聊',
    categorySlug: 'mingxing-siliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20atmosphere%20with%20silhouette%20of%20a%20person%20behind%20frosted%20glass%2C%20mysterious%20lighting%2C%20film%20noir%20style%2C%20dramatic%20shadows%2C%20minimalist%20composition%2C%20dark%20background%20with%20soft%20warm%20light%20leak%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=1000&seq=hero-article-1&orientation=portrait',
    excerpt: '近日有网友爆料某顶流男星深夜与女粉丝私会，并提供了长达三小时的录音证据...',
    date: '2026-07-07',
    views: '1289万',
    hot: true,
    tags: ['顶流男星', '录音曝光', '深夜私会'],
    author: '吃瓜前线记者',
    content: `<p>近日，一条爆炸性消息在网络上迅速发酵——某当红顶流男星被爆与一名女粉丝深夜私会，并且相关录音证据已在多个社交平台流传。据爆料者称，该录音长达三小时，内容涉及两人私密对话的全过程。</p>
<h2>录音内容概述</h2>
<p>据知情人士透露，录音中男方的声音特征与某顶流男星高度吻合。对话内容显示，两人并非第一次见面，此前已在多个场合有过接触。录音中，男方多次表达了对女方的"特殊感情"，并承诺会给予资源方面的帮助。</p>
<p>更令人震惊的是，录音中还涉及到了对圈内其他艺人的评价和爆料，内容尺度之大令人咋舌。</p>
<h2>粉丝反应两极化</h2>
<p>消息爆出后，该男星的粉丝阵营迅速分裂。一部分粉丝坚决否认录音真实性，认为这是一场有预谋的抹黑行动；而另一部分粉丝则表示极度失望，纷纷在社交平台表达脱粉意愿。</p>
<p>截至目前，该男星及其工作室尚未对此事做出任何公开回应。</p>
<h2>圈内人士看法</h2>
<p>多位娱乐圈资深人士对此事发表了看法。某知名娱乐记者表示："这种事情在圈内并不罕见，但被爆出来的确实不多。如果录音属实，对这位男星的事业打击将是毁灭性的。"</p>
<p>法律界人士则指出，如果录音是在未经当事人同意的情况下录制的，爆料者和传播者可能面临侵犯隐私权的法律风险。</p>
<h2>后续发展</h2>
<p>目前，相关话题已在各大社交平台登上热搜榜首。有消息称，该男星的代言品牌已开始紧急评估是否继续合作。我们将持续关注此事的后续发展。</p>`,
  },
  {
    id: 'article-2',
    title: '百万粉网红直播间翻车，前男友突然闯入揭露造假黑幕',
    slug: 'baiwan-wanghong-zhibo-fanche',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20studio%20with%20bright%20ring%20light%20and%20camera%20equipment%2C%20chaotic%20atmosphere%2C%20dark%20warm%20tones%2C%20editorial%20photography%20style%2C%20high%20contrast%20lighting%2C%20minimalist%20composition%2C%20tense%20mood&width=800&height=1000&seq=hero-article-2&orientation=portrait',
    excerpt: '昨晚某百万粉丝网红正在直播带货时，前男友突然闯入直播间...',
    date: '2026-07-06',
    views: '987万',
    hot: true,
    tags: ['直播翻车', '网红塌房', '造假'],
    author: '黑料观察员',
    content: `<p>昨晚八点，拥有超过两百万粉丝的知名带货网红"小甜甜CC"在直播过程中遭遇了职业生涯最大的翻车事故。正当她在推荐一款"自用三个月"的护肤品时，一名自称是她前男友的男子突然闯入直播间，当着数十万观众的面揭露了一系列造假内幕。</p>
<h2>现场混乱</h2>
<p>根据直播录屏显示，该男子闯入后直接走到镜头前，大声说道："你根本不用这个产品！你的脸是医美做的，这些产品都是品牌方免费送的，你转手就挂闲鱼卖了！"</p>
<p>直播间瞬间炸锅，弹幕疯狂滚动。网红本人当场愣住，随后试图解释却语无伦次。直播在混乱中被工作人员紧急切断。</p>
<h2>前男友爆料要点</h2>
<p>据该男子后续在社交平台发布的详细声明，他揭露了以下几点：</p>
<ul>
<li>网红的"素颜出镜"实际上都是经过精心伪装的淡妆</li>
<li>所有推荐的护肤品从未真正使用过，全是品牌方寄来的样品</li>
<li>标榜"自用三个月见效"的减肥产品，她本人从未碰过</li>
<li>直播间内"随机连线"的粉丝其实都是安排好的托</li>
</ul>
<h2>行业乱象反思</h2>
<p>此事件引发了网友对直播带货行业诚信问题的广泛讨论。有消费者权益保护组织呼吁加强对直播带货的监管，建立更严格的虚假宣传惩处机制。</p>
<p>截至目前，多个品牌方已宣布终止与该网红的合作关系。</p>`,
  },
  {
    id: 'article-3',
    title: '知名女星与经纪人聊天记录曝光，涉及多位圈内大佬',
    slug: 'nvxing-jingjiren-liaotian',
    category: '黑料今日',
    categorySlug: 'heiliao-jinri',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20smartphone%20screen%20glowing%20in%20the%20dark%2C%20chat%20messages%20visible%20on%20screen%2C%20dramatic%20low%20key%20lighting%2C%20film%20noir%20aesthetic%2C%20dark%20background%2C%20editorial%20photography%2C%20moody%20atmosphere&width=800&height=1000&seq=hero-article-3&orientation=portrait',
    excerpt: '近日一份据称是某知名女星与经纪人的私密聊天记录被曝光...',
    date: '2026-07-06',
    views: '1567万',
    hot: false,
    tags: ['聊天记录', '女星', '圈内大佬'],
    author: '娱乐圈内参',
    content: `<p>一份据称是某知名一线女星与其经纪人的微信聊天记录截图近日在网络上被大量传播。聊天内容涉及该女星对多位圈内大佬的评价、片酬谈判内幕，以及一些鲜为人知的娱乐圈潜规则。</p>
<h2>聊天记录核心内容</h2>
<p>根据被曝光的聊天记录，该女星在对话中详细讨论了与某知名导演的合作细节，其中包括"特殊要求"和高达八位数的"额外费用"。此外，聊天记录中还提到了她对同行女演员的贬低性评价，措辞之尖锐令人震惊。</p>
<p>其中一段对话显示，该女星曾要求经纪人"想办法搞掉"一位竞争同一角色的年轻演员，暗示使用了一些不正当手段。</p>
<h2>经纪人身份成谜</h2>
<p>目前尚不清楚聊天记录是如何泄露的。有分析认为，可能是该经纪人手机被黑，也有猜测是内部人员故意泄露。该经纪人的社交账号已全部设为私密，无法联系到本人进行求证。</p>
<h2>涉及多位知名人士</h2>
<p>聊天记录中被提及的圈内人士包括三位知名导演、两位制片人和四位一线演员。其中一位被提及的导演已在社交平台发文称"清者自清"，其余人暂未回应。</p>
<h2>法律风险分析</h2>
<p>律师表示，如果聊天记录内容属实，涉及的行为可能构成商业贿赂、不正当竞争等违法问题。相关部门或将对涉事人员展开调查。同时，泄露和传播他人私密聊天记录的行为也可能面临法律追责。</p>`,
  },
  {
    id: 'daily-1',
    title: '选秀节目内定冠军？知情人曝光投票数据造假内幕',
    slug: 'xuanxiu-neiding-guanjun',
    category: '综艺黑幕',
    categorySlug: 'zongyi-heimu',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20voting%20screen%20with%20numbers%20and%20graphs%2C%20dark%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20business%20investigation%20theme&width=700&height=500&seq=daily-1&orientation=landscape',
    excerpt: '知情人士曝光某大型选秀节目的投票数据存在严重造假，冠军早已内定...',
    date: '2026-07-07',
    views: '89万',
    hot: true,
    tags: ['选秀', '数据造假', '内定'],
    author: '综艺打假人',
    content: `<p>一档正在热播的大型选秀节目近日被曝出投票数据严重造假。一位自称曾在节目组工作的知情人向本平台提供了大量内部资料，显示所谓的"观众投票"实际上完全由节目组操控。</p>
<h2>数据造假细节</h2>
<p>据知情人透露，节目的投票系统看似公开透明，实际上后台设置了多重操控机制。选手的票数增长曲线完全按照节目组预设的"剧本"进行，某些选手的票数甚至会在短时间内出现不合理的暴增或暴跌。</p>
<p>"你们看到的那些感人肺腑的逆袭故事，投票数据都是提前写好脚本的，"知情人表示，"冠军人选在节目开播前就已经定好了。"</p>
<h2>经济利益驱动</h2>
<p>据了解，内定冠军的背后涉及巨大的商业利益。冠军选手的经纪约、代言合同、后续资源等都由节目制作方和相关资本方提前分配完毕。粉丝的真金白银投票，实际上只是为这场精心策划的表演买单。</p>
<h2>粉丝反应</h2>
<p>消息爆出后，众多粉丝表示愤怒和失望。多个粉丝后援会已联合发表声明，要求节目组公开全部投票数据并接受第三方审计。有粉丝表示已经向消费者协会投诉。</p>`,
  },
  {
    id: 'daily-2',
    title: '知名夫妻档网红被曝早已离婚，合伙割韭菜真相曝光',
    slug: 'fuqidang-wanghong-lihun',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Split%20apart%20wedding%20rings%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20minimalist%20composition%2C%20film%20noir%20style%2C%20editorial%20photography&width=700&height=500&seq=daily-2&orientation=landscape',
    excerpt: '粉丝眼中恩爱的夫妻档网红，实际上早已离婚却仍在合体直播带货...',
    date: '2026-07-07',
    views: '156万',
    hot: true,
    tags: ['夫妻档', '假离婚', '割韭菜'],
    author: '网红掘墓人',
    content: `<p>在短视频平台上拥有超过五百万粉丝的"甜蜜夫妻档"网红组合，被曝出实际上已于两年前秘密离婚。然而两人却在离婚后继续以恩爱夫妻的形象合体直播、接广告、卖货，累计收入据估计超过三千万元。</p>
<h2>真相浮出水面</h2>
<p>一位自称是两人共同好友的网友在社交平台爆料，两人早在2024年初就已办理离婚手续。但为了维持"夫妻档"的商业价值和流量热度，两人达成协议，继续以夫妻名义进行商业活动，所得收益按比例分成。</p>
<p>该网友还晒出了两人的离婚协议书部分内容的照片作为证据，虽然关键信息被打了码，但发文IP和细节描述的可信度极高。</p>
<h2>商业版图曝光</h2>
<p>据调查，两人通过"恩爱夫妻"人设建立了庞大的商业版图，包括自有品牌的美妆产品、家居用品以及付费情感课程。其中付费课程售价高达2999元，号称"传授十年婚姻保鲜秘诀"，购买者超过两万人。</p>
<h2>法律与道德争议</h2>
<p>律师指出，两人隐瞒离婚事实并以此进行商业宣传，可能涉嫌虚假宣传和消费欺诈。如果消费者能够证明购买决策受到了"夫妻人设"的影响，有权要求退款。</p>
<p>目前，两人所有社交账号已经关闭评论功能，暂未做出公开回应。</p>`,
  },
  {
    id: 'daily-3',
    title: '某当红小生与多位女星暧昧聊天记录流出',
    slug: 'danghong-xiaosheng-aimu',
    category: '明星私聊',
    categorySlug: 'mingxing-siliao',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20messaging%20app%20on%20dark%20bed%20sheets%2C%20intimate%20moody%20lighting%2C%20film%20noir%20aesthetic%2C%20editorial%20photography%2C%20minimalist%20composition&width=700&height=500&seq=daily-3&orientation=landscape',
    excerpt: '近日一份涉及某当红小生与多位女星的暧昧聊天记录在网络上疯传...',
    date: '2026-07-06',
    views: '312万',
    hot: false,
    tags: ['当红小生', '暧昧聊天', '多位女星'],
    author: '八卦探测器',
    content: `<p>一份据称是某当红95后小生与多位女星的暧昧聊天记录近日在网络上被广泛传播。聊天内容尺度惊人，涉及与至少四位圈内女艺人的私密对话。</p>
<h2>聊天记录内容</h2>
<p>根据曝光的截图，该男星在聊天中使用了大量暧昧甚至露骨的语言，与多位女星保持着不同程度的亲密关系。部分对话截图显示，该男星疑似同时与多人保持暧昧，且对话时间存在重叠。</p>
<p>值得注意的是，被提及的女星中包括一位已婚女演员，这一细节引发了更大的争议。</p>
<h2>粉丝维护与脱粉</h2>
<p>该男星的粉丝群体出现了严重的分裂。核心粉丝坚称聊天记录为伪造，是竞争对手的恶意抹黑。但已经有多个粉丝站宣布关闭，大量粉丝在超话中表达失望并宣布脱粉。</p>
<h2>商业影响</h2>
<p>据悉，该男星目前有多个代言在身，包括两个国际奢侈品牌和一个国民级快消品牌。有消息称品牌方已经开始进行内部评估，考虑是否提前终止合作。</p>`,
  },
  {
    id: 'daily-4',
    title: '综艺节目剧本泄露：嘉宾人设全是演出来的？',
    slug: 'zongyi-juben-xielou',
    category: '综艺黑幕',
    categorySlug: 'zongyi-heimu',
    image: 'https://readdy.ai/api/search-image?query=Script%20papers%20scattered%20on%20a%20dark%20table%20with%20dim%20spotlight%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20minimalist%20aesthetic&width=700&height=500&seq=daily-4&orientation=landscape',
    excerpt: '某热门综艺节目内部剧本被曝光，嘉宾们的人设、冲突甚至是感情线都是提前设计好的...',
    date: '2026-07-06',
    views: '78万',
    hot: false,
    tags: ['综艺', '剧本泄露', '人设'],
    author: '电视民工',
    content: `<p>一份据称是某热门综艺节目的内部剧本近日在网络上被曝光。这份长达数十页的文档详细记录了每位嘉宾的"人设定位"、"冲突节点"和"情感走向"，甚至连"即兴反应"都是提前设计好的。</p>
<h2>剧本核心内容</h2>
<p>曝光的剧本文件显示，节目组为每位嘉宾都设定了详细的人设标签和故事线。例如某位以"耿直"著称的嘉宾，其所有"口无遮拦"的发言都是提前写好的台词；某对在节目中"日久生情"的CP，实际上在节目开拍前就已确定要炒CP。</p>
<p>剧本中还包含了"冲突引爆点"的精确时间安排，甚至连什么时候该哭、什么时候该笑都有明确指示。</p>
<h2>行业惯例？</h2>
<p>有业内人士表示，综艺节目有一定程度的"剧本引导"在行业内并不罕见，但像这样详细到每句话、每个反应的剧本确实少见。"这已经不是引导了，完全是在演戏。"该人士评论道。</p>
<h2>观众反应</h2>
<p>消息爆出后，大量观众表达了被欺骗的愤怒感。"我们真情实感追了那么久，原来全都是剧本？"一位忠实观众在社交平台留言。该节目最新一期的收视率已出现明显下滑。</p>`,
  },
  {
    id: 'daily-5',
    title: '网红圈"假名媛"产业链曝光：租豪车豪宅骗粉丝',
    slug: 'jia-mingyuan-chanyelian',
    category: '黑料今日',
    categorySlug: 'heiliao-jinri',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20car%20keys%20and%20designer%20bags%20on%20dark%20surface%2C%20mysterious%20moody%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20film%20noir%20aesthetic&width=700&height=500&seq=daily-5&orientation=landscape',
    excerpt: '调查发现，许多网红通过租赁豪车、豪宅和高仿奢侈品来营造"名媛"人设...',
    date: '2026-07-05',
    views: '234万',
    hot: false,
    tags: ['假名媛', '产业链', '网红'],
    author: '消费打假先锋',
    content: `<p>近年来，社交平台上涌现了大量"名媛风"网红，她们晒豪车、住豪宅、背名牌包，营造出令人羡慕的奢华生活。然而本平台深入调查发现，这背后隐藏着一条完整的"假名媛"产业链。</p>
<h2>产业链运作模式</h2>
<p>调查发现，目前市面上存在着专门为网红提供"名媛道具"的租赁公司。这些公司可以提供豪车租赁（按小时计费）、豪宅短租（按场景计费）、高仿奢侈品租赁等一条龙服务。</p>
<p>据了解，一辆法拉利的日租价格在3000-5000元不等，而一栋豪华别墅的场景拍摄费用也仅需2000-3000元。网红们通过集中拍摄大量素材，可以在一天内产出足够使用一个月的"名媛日常"内容。</p>
<h2>变现路径</h2>
<p>建立"名媛人设"后，这些网红的变现方式多种多样：</p>
<ul>
<li>开设"名媛培训班"，教授"如何吸引高净值人群"，收费从几千到几万元不等</li>
<li>推广各类理财产品、医美项目，宣称自己"亲测有效"</li>
<li>发展下线代理，通过传销式的方式扩大收入</li>
</ul>
<h2>受害者众多</h2>
<p>不少年轻女性成为了"假名媛"的受害者。她们被这些网红营造的虚假生活方式所迷惑，不仅花费大量金钱购买课程和产品，有些甚至借贷消费。有受害者表示："我以为跟着她们就能过上那种生活，结果欠了一屁股债。"</p>`,
  },
  {
    id: 'daily-6',
    title: '知名经纪人被曝克扣艺人收入，涉及金额超千万',
    slug: 'jingjiren-kekou-shouru',
    category: '黑料今日',
    categorySlug: 'heiliao-jinri',
    image: 'https://readdy.ai/api/search-image?query=Financial%20documents%20and%20calculator%20on%20dark%20desk%2C%20dramatic%20lighting%2C%20investigation%20theme%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20dark%20atmosphere&width=700&height=500&seq=daily-6&orientation=landscape',
    excerpt: '某知名经纪人被旗下多名艺人联名起诉，指控其长期克扣艺人演出收入...',
    date: '2026-07-05',
    views: '189万',
    hot: false,
    tags: ['经纪人', '克扣收入', '联名起诉'],
    author: '娱乐圈打工人',
    content: `<p>娱乐圈再度爆出经纪人丑闻。某知名经纪人被旗下至少五名艺人联名起诉，指控其在过去五年间通过做假账、虚报支出等方式，累计克扣艺人演出收入超过千万元。</p>
<h2>起诉详情</h2>
<p>根据法院公开的起诉书，原告方指控该经纪人存在以下行为：</p>
<ul>
<li>在艺人不知情的情况下，私自将演出报价提高30%-50%，差价部分据为己有</li>
<li>虚构各项"活动支出"和"公关费用"，从艺人收入中扣除</li>
<li>强制艺人接受不合理分成比例，最高达到收入的70%归经纪人所有</li>
<li>扣押艺人部分收入，以"正在走账"为由长期拖延支付</li>
</ul>
<h2>艺人遭遇</h2>
<p>一位参与起诉的艺人透露，她曾在某次商演后收到经纪人发来的账目，扣除各种费用后，一场报价50万的演出她最后只拿到不到8万元。"我一直以为行业就是这样，后来和同行交流才知道被坑了。"</p>
<h2>行业反思</h2>
<p>此事件引发了行业对经纪制度的大讨论。有业内人士呼吁建立更透明的艺人收入管理机制，引入第三方审计，保障艺人的合法权益。中国演出行业协会也表示将关注此事进展。</p>`,
  },
  {
    id: 'featured-1',
    title: '娱乐圈年度最大瓜：某制作人被多人联名举报潜规则',
    slug: 'yulequan-niandu-zuida-gua',
    category: '黑料今日',
    categorySlug: 'heiliao-jinri',
    image: 'https://readdy.ai/api/search-image?query=Empty%20theater%20stage%20with%20single%20spotlight%2C%20dark%20dramatic%20atmosphere%2C%20red%20velvet%20curtains%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20minimalist%20aesthetic&width=900&height=600&seq=featured-1&orientation=landscape',
    excerpt: '多位圈内人士联名举报某知名制作人利用职务之便进行潜规则操作...',
    date: '2026-07-07',
    views: '2156万',
    hot: true,
    tags: ['制作人', '潜规则', '联名举报'],
    author: '正义联盟',
    content: `<p>娱乐圈本年度迄今为止最大的丑闻——某知名影视制作人被超过十位圈内人士联名举报，指控其长期利用职务之便进行潜规则操作。举报信已提交至相关部门，并附有大量证据材料。</p>
<h2>举报内容</h2>
<p>举报信详细列举了该制作人的多项不当行为，包括但不限于：以角色分配为条件要求不正当交易、利用投资方身份打压拒绝其要求的艺人、干预剧组人事安排以安插关系人员等。</p>
<p>一位参与举报的女演员表示："这种情况已经持续太久了，我们受够了。这次站出来，是希望这个行业能变得更好。"</p>
<h2>制作人身份</h2>
<p>虽然举报信中未直接点名，但根据描述的多部作品和合作对象，网友已基本锁定该制作人的身份。该制作人在业内地位极高，参与制作的多部作品曾获得重要奖项。目前该制作人的工作室已发布声明否认所有指控，并表示将通过法律途径维护名誉。</p>
<h2>行业震荡</h2>
<p>此事件在娱乐圈引发巨大震动。多家影视公司紧急召开内部会议，重申职业道德规范。多位知名演员公开表态支持举报者，呼吁行业彻底肃清不正之风。</p>`,
  },
  {
    id: 'featured-2',
    title: '某女团成员私下吐槽公司压榨，录音文件流出',
    slug: 'nvtuan-chengyuan-tucao',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20style%20dance%20practice%20room%20with%20mirrors%2C%20dim%20lighting%2C%20empty%20and%20lonely%20atmosphere%2C%20minimalist%20composition%2C%20melancholic%20mood%2C%20editorial%20photography%2C%20cool%20tones&width=900&height=600&seq=featured-2&orientation=landscape',
    excerpt: '一段据称是某女团成员的私下录音被曝光，录音中该成员详细讲述了公司的种种不公...',
    date: '2026-07-06',
    views: '567万',
    hot: false,
    tags: ['女团', '录音曝光', '公司压榨'],
    author: '偶像观察家',
    content: `<p>一段据称是某当红女团成员私下吐槽公司的录音文件在网络上被曝光。录音中，该成员详细描述了公司的种种压榨行为，包括超长工作时间、不合理的收入分配以及严格的人身控制。</p>
<h2>录音核心内容</h2>
<p>根据录音内容，该成员透露了以下信息：</p>
<ul>
<li>团队每天训练时间超过14小时，几乎没有休息日</li>
<li>成员每月实际到手收入不足万元，而公司从团队收入中抽取超过80%</li>
<li>成员被禁止私自使用手机，所有社交账号由公司统一管理</li>
<li>体重不达标会被罚款甚至体罚</li>
<li>合约期限长达十年，提前解约需支付天价违约金</li>
</ul>
<h2>粉丝反应</h2>
<p>录音曝光后，该女团的粉丝群体反应强烈。大量粉丝在社交平台发起话题，要求公司改善成员待遇。有粉丝甚至组织了线下应援改为维权的活动。</p>
<h2>公司回应</h2>
<p>该女团所属经纪公司发布声明称，录音内容"严重失实"，是"恶意剪辑和断章取义"，并表示将追究相关人员的法律责任。但公司并未就具体指控做出逐一回应。</p>`,
  },
  {
    id: 'featured-3',
    title: '知名导演私生活混乱？多位女演员实名爆料',
    slug: 'zhiming-daoyan-sishenghuo',
    category: '明星私聊',
    categorySlug: 'mingxing-siliao',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20dark%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20film%20noir%20style%2C%20moody%20composition%2C%20minimalist%20aesthetic%2C%20high%20contrast&width=900&height=600&seq=featured-3&orientation=landscape',
    excerpt: '近日多名女演员站出来实名举报某知名导演长期利用职务之便...',
    date: '2026-07-05',
    views: '1890万',
    hot: false,
    tags: ['导演', '实名举报', '女演员'],
    author: '影坛清道夫',
    content: `<p>继制作人潜规则丑闻之后，娱乐圈再爆重磅消息。三位女演员通过社交媒体实名举报某知名电影导演，指控其在过去十余年间存在多种不当行为。</p>
<h2>实名举报内容</h2>
<p>三位女演员在联合声明中表示，该导演在选角和拍摄过程中，多次利用职务便利进行不当接触。其中一位女演员声称自己在拒绝了导演的要求后，原本定好的女主角被临时换掉。</p>
<p>"我们选择站出来，不是为了炒作，而是希望不要再有年轻演员受到伤害。"联合声明中写道。</p>
<h2>导演身份</h2>
<p>根据三位女演员的描述和提供的部分证据，网友已锁定该导演身份。该导演是华语电影界的重要人物，多次获得国际电影节奖项，在业内享有极高声誉。</p>
<p>目前该导演尚未做出任何回应，其工作室电话一直处于无人接听状态。</p>
<h2>行业呼吁</h2>
<p>此事件推动了娱乐圈#MeToo运动的进一步发展。多个影视行业协会发表声明，呼吁建立行业黑名单制度，对有不当行为的人员进行联合抵制，为从业者创造安全、公平的工作环境。</p>`,
  },
  {
    id: 'video-1',
    title: '独家：某选秀冠军后台发飙全过程',
    slug: 'xuanxiu-guanjun-houtai',
    category: '黑料视频',
    categorySlug: 'heiliao-shipin',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20area%20of%20a%20TV%20studio%20with%20dramatic%20lighting%2C%20empty%20corridor%2C%20mysterious%20atmosphere%2C%20warm%20tungsten%20light%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20minimalist%20style&width=640&height=480&seq=video-1&orientation=landscape',
    excerpt: '一段在后台偷拍的视频显示，某选秀节目冠军在得知自己排名后当场发飙...',
    date: '2026-07-07',
    views: '128万',
    hot: true,
    tags: ['选秀冠军', '后台', '发飙'],
    author: '后台偷拍哥',
    content: `<p>一段据称是在某大型选秀节目后台偷拍的视频近日在网络上疯传。视频画面显示，某位刚刚获得周冠军的选手在后台休息室突然情绪失控，对工作人员大发雷霆。</p>
<h2>视频内容还原</h2>
<p>根据视频画面和声音，该选手发飙的原因据称是发现自己的"冠军"只是节目组安排的"剧本"，实际观众投票数据远低于其他选手。该选手在视频中大喊："你们当我是什么？道具吗？"</p>
<p>视频中可以看到，多位工作人员试图安抚该选手，但效果不佳。最终该选手摔门而出，场面一度十分尴尬。</p>
<h2>视频真实性</h2>
<p>目前尚无法100%确认视频的真实性。有网友指出视频中的环境细节与该节目后台完全吻合，也有人认为这可能是节目组自导自演的炒作。</p>
<h2>节目组回应</h2>
<p>该节目组官方暂未对此视频做出回应。但据内部人士透露，节目组已紧急召开会议讨论此事的处理方案。</p>`,
  },
  {
    id: 'video-2',
    title: '网红情侣分手内幕：三年聊天记录全公开',
    slug: 'wanghong-qinglv-fenshou',
    category: '黑料视频',
    categorySlug: 'heiliao-shipin',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20on%20a%20dark%20wooden%20table%2C%20screen%20showing%20chat%20interface%2C%20dim%20ambient%20lighting%2C%20moody%20atmosphere%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20minimalist%20aesthetic&width=640&height=480&seq=video-2&orientation=landscape',
    excerpt: '一对网红情侣分手后，其中一方公开了两人三年的全部聊天记录...',
    date: '2026-07-06',
    views: '96万',
    hot: false,
    tags: ['网红情侣', '聊天记录', '分手'],
    author: '感情纠纷观察员',
    content: `<p>曾被誉为"最甜CP"的一对网红情侣在宣布分手后，事态急转直下。女方在社交平台公开了两人的全部聊天记录，时间跨度长达三年，内容令人震惊。</p>
<h2>聊天记录揭露</h2>
<p>根据公开的聊天记录，这对情侣的关系实际上早已名存实亡。聊天内容显示：</p>
<ul>
<li>男方在恋爱期间多次出轨，同时与至少三人保持暧昧关系</li>
<li>两人所谓的"甜蜜日常"视频全是按剧本拍摄的，实际生活中经常争吵</li>
<li>分手的原因是男方要求女方签署"保密协议"被拒</li>
<li>男方曾威胁女方如果公开真相，就让她"在圈子里混不下去"</li>
</ul>
<h2>商业利益纠纷</h2>
<p>除了感情问题，两人还存在严重的商业纠纷。据悉，两人的联名品牌价值超过千万，分手后对于品牌归属和收益分配产生了巨大分歧。</p>
<h2>网友反应</h2>
<p>聊天记录公开后，舆论几乎一边倒地支持女方。男方的社交账号粉丝数在24小时内暴跌超过50万。多个品牌方紧急撤下了与该男网红的合作内容。</p>`,
  },
];

export const categorySlugMap: Record<string, string> = {
  'heiliao-jinri': '黑料今日',
  'wanghong-tafang': '网红塌房',
  'mingxing-siliao': '明星私聊',
  'heiliao-shipin': '黑料视频',
  'zongyi-heimu': '综艺黑幕',
};

export const categoryDescriptions: Record<string, string> = {
  'heiliao-jinri': '每日最新黑料爆料，娱乐圈不为人知的秘密，尽在黑料今日专栏。实时更新，吃瓜不停。',
  'wanghong-tafang': '网红圈塌房实录，百万粉丝网红翻车现场。人设崩塌、直播事故、虚假宣传全记录。',
  'mingxing-siliao': '明星私下聊天记录曝光，娱乐圈私密对话大公开。那些你不知道的明星真实一面。',
  'heiliao-shipin': '黑料实拍视频专区，独家偷拍、录音曝光、聊天截图。眼见为实，耳听为证。',
  'zongyi-heimu': '综艺节目幕后黑幕揭秘，选秀内定、剧本泄露、不公平待遇。台前光鲜，台后黑暗。',
};